import { render, staticRenderFns } from "./collapseContent.vue?vue&type=template&id=16a2b9ba&scoped=true"
import script from "./collapseContent.vue?vue&type=script&lang=js"
export * from "./collapseContent.vue?vue&type=script&lang=js"
import style0 from "./collapseContent.vue?vue&type=style&index=0&id=16a2b9ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a2b9ba",
  null
  
)

export default component.exports